class landingProductCreamer extends HTMLElement {
    constructor() {
        super();

        this.stepBlocks = this.querySelectorAll('[data-step]')
        this.finalBlock = this.querySelector('.final-step__list')
        this.productsElements = this.querySelectorAll('[data-step-name="product"]')
        
        this.addButton = this.querySelector('.final-step__product__button')
        
        this.currentFlavor = null;
        this.variantId = null
        this.quantity = null
        this.discountCode = null
        this.uniqueProperty = this.dataset.landingProperty || null;

        this.currentStep = 0;
        this.nextStep = 0;
    }

    connectedCallback() {
        this.clearCart()
        this.stepBlocks.forEach(stepBlock => {
            stepBlock.addEventListener('click', () => this.handleClickOnStep(stepBlock))
        })
        this.addButton?.addEventListener('click', () => {
            this.clearCart()
            .then(() => this.addToCart())
        })
    }

    handleClickOnStep(stepBlock) {
        const stepWrapper = stepBlock.closest('.step-block');
        const currentStepBlocks = stepWrapper?.querySelectorAll('[data-step]')
        currentStepBlocks.forEach(block => {
            const isCurrentBlock = block == stepBlock
            block.classList.toggle('step-block__item--active', isCurrentBlock)
        })

        const {step, flavorName, stepName: blockType} = stepBlock.dataset
        this.currentStep = +step;
        this.nextStep = +step + 1;
        if (flavorName) this.currentFlavor = flavorName;

        this.openStep(this.nextStep)
        this.showProducts(this.currentFlavor, blockType)

        if (blockType == 'product') {
            this.setFormData(stepBlock);
            this.finalBlock?.classList.add('final-step__list--active');
        }
    }

    openStep(step) {
        const stepWrapper = this.querySelector(`[data-step="${step}"]`)?.closest('.step-block');
        stepWrapper?.classList.add('step-block--active');

        stepWrapper?.scrollIntoView({ block: "start", behavior: "smooth" })
    }

    showProducts(flavor, blockType) {
        this.productsElements.forEach(product => {
            const isCurrentFlavor = product.dataset.flavor == flavor;
            const isPreselectedProduct = product.classList.contains('step-block__item--preselected')
            
            product.classList.toggle('step-block__item--hidden', !isCurrentFlavor)
            if (isCurrentFlavor && isPreselectedProduct) {
                if (blockType != 'product') {
                    this.finalBlock?.classList.add('final-step__list--active');
                    product.classList.add('step-block__item--active')
                }
                this.setFormData(product) 
            }
        })
    }

    setFormData(product) {
        const {variantId, discountCode, quantity, price} = product.dataset

        this.variantId = variantId
        this.quantity = quantity
        this.discountCode = discountCode

        if (this.addButton) this.addButton.querySelector('.price__original').innerText = price;
    }

    clearCart() {
        return fetch('/cart/clear.js')
    }

    async addToCart() {
        let bodyData = {
            'items': [{
                'id': Number(this.variantId),
                'quantity': Number(this.quantity),
            }]
        }

        if (this.uniqueProperty) {
            bodyData.items[0].properties = {
              _landingSubscription: this.uniqueProperty
            }
        }

        if(localStorage.getItem('first-visited-page')){
            bodyData.items[0].properties = bodyData.items[0].properties || {};
            bodyData.items[0].properties['_first_visited_page'] = localStorage.getItem('first-visited-page');
        }

        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', 
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(bodyData)
            }
        );

        if (response.ok) window.location.href = this.discountCode ? `/checkout?discount=${this.discountCode}` : '/checkout'
    }
}

customElements.define('landing-product-creamer', landingProductCreamer)